module.exports = __webpack_public_path__ + "img/personel-flat-card-3.png";